import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
import ElementUI from 'element-ui'
import './assets/css/global.css'
import axios from 'axios'
// 导入富文本编辑器
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import VueQuillEditor from 'vue-quill-editor'
// import 'quill/dist/quill.core.css' // import styles
// import 'quill/dist/quill.snow.css' // for snow theme
// import 'quill/dist/quill.bubble.css' // for bubble theme
// ******
import './assets/icon/iconfont.css'
import TreeTable from 'vue-table-with-tree-grid'
import Router from 'vue-router' 
import VueWechatTitle from 'vue-wechat-title'
import Plugin from 'v-fit-columns'
// 开发环境打开devtools
Vue.config.devtools = true

// 默认点击背景不关闭弹窗
ElementUI.Dialog.props.closeOnClickModal.default = false
Vue.use(VueQuillEditor)
Vue.use(VueWechatTitle)
Vue.use(Plugin)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}
Vue.use(ElementUI)
var httpApi = 'https://www.mellotu.com' // 测试服务器接口使用。--弃用
// var httpApi = 'http://127.0.0.1:1003' // 开发的时候应用
// var httpApi = 'http://121.41.70.54:1003' // 开发的时候应用
// var httpApi = 'https://huaian001.pzeiot.asia:1032' // 部署到服务器时使用
 var httpApiImg = 'https://www.mellotu.com' // 上传图片的地址需要调用
// var httpApiImg = 'https://192.168.2.8:1032' // 上传图片的地址需要调用

// console.log(process.env.NODE_ENV)
axios.defaults.baseURL = httpApi
//  axios.defaults.baseURL = httpApi

window.sessionStorage.setItem('httpApiImg', httpApiImg)
window.sessionStorage.setItem('http_api', httpApi)
window.sessionStorage.setItem('pageSize', 10) //  单页记录数量

// 防止出现重复路由 的情况
// 改造在axios请求之前 Authorization 挂载 token
axios.interceptors.request.use((config) => {
  config.headers.Authorization = window.sessionStorage.getItem('token')
  return config
})
Vue.prototype.$http = axios
// 添加实例 $http,在所有页面都可以调用该实例
Vue.config.productionTip = false
Vue.component('tree-table', TreeTable)
new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app') // 挂载
